// extracted by mini-css-extract-plugin
export var footer = "f_bp";
export var footerTop = "f_bq";
export var footerTopQrcode = "f_br";
export var footerTopQrcodeBox = "f_bs";
export var footerTopQrcodeBoxImg = "f_bt";
export var footerTopQrcodeText = "f_bv";
export var footerTopQrcodeTextHighlight = "f_bw";
export var footerTopRight = "f_bx";
export var footerTopRightLogo = "f_by";
export var footerTopRightDescription = "f_bz";
export var footerTopRightAddress = "f_bB";
export var footerBottom = "f_bC";